import Markdown from 'markdown-to-jsx'

import { getTranslate } from '../../utilities/i18n'
import CounsellingBannerInactive from '../counselling/CounsellingBannerInactive'
import DiagnosisTeaserPageRouter from '../diagnosis/teaser/DiagnosisTeaserPageRouter'
import Icon from '../icons/Icon'
import ServiceDropdown from '../ServiceDropdown'

type Props = {
  readonly className: string
  readonly service: any
  readonly showDiagnosisTeaser: boolean
  readonly isCounselling: boolean
}

const ServiceContent: React.FC<Props> = ({ className, service, showDiagnosisTeaser, isCounselling }) => {
  const { t } = getTranslate()
  return (
    <div className={className}>
      <div className="relative">
        <div className="container">
          <div className="therapists-wrapper__limited-title-wrapper">
            <ServiceDropdown align="center" className="mb-8 mt-2 max-w-[420px] tablet:mb-8 laptop:mb-12 laptop:mt-4" />

            <div className="font-regular mb-0 max-w-[600px] px-4 tablet:mb-2 tablet:px-0 laptop:mb-6">
              {isCounselling ? <h2>{service?.title}</h2> : <Markdown>{t('therapistFilter.title')}</Markdown>}
            </div>
          </div>

          {showDiagnosisTeaser && <DiagnosisTeaserPageRouter className="mx-auto max-w-[800px] px-4 tablet:px-0" />}
          {isCounselling && (
            <>
              {service?.intro && (
                <div className="mx-auto my-8 flex max-w-[800px] flex-row justify-center text-center text-base text-text-color">
                  <Markdown>{service.intro}</Markdown>
                </div>
              )}
              <CounsellingBannerInactive />
              <div className="flex items-center justify-center">
                <ul className="m-0 mx-auto mb-10 flex grid max-w-[740px] list-none grid-cols-1 flex-col p-4 pt-0 tablet:w-full tablet:grid-cols-3 tablet:flex-row tablet:justify-between">
                  {service?.advantagesList?.map((advantage, key) => {
                    return (
                      <li
                        key={`advantagesList-${key}`}
                        className="mb-4 flex items-center text-base font-bold tablet:mb-0 tablet:px-2"
                      >
                        <Icon color="primary" icon="check-reverse" className="mr-4" />
                        {advantage.text}
                      </li>
                    )
                  })}
                </ul>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default ServiceContent
